module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAvCAYAAADw46qXAAABAklEQVRYhe3WTQ7BQBjG8b/GwudJSCR24nvNHUTCHdxAcBwuQCI2jRUnEKw5gYVpUsKYmbQWvE8yi84zmV+bdJomfN/HIgVgDLTU9RIYAXvTDZKW2AbIh+a6Cq8AO5NNPAtw9oQFyQFT001swKZj5wxmHDtnMJIIKOD/ggVgDlzUmKs5q2+paUrAGsiG5rpAG6jF8YTTJyxIFpjEAdY1XSMOMK3pUj/zlgpIEVgAVzUWai7yJIEysOLx7HS4/xw1gG2UoMeHgxolFoBVTV+LA0xpel3nDH41AgoooIACCijgv4BHTR/uDpp1Z9N1HjAETi/Kk+qCDN7c3BHoha6HmnX9G4sCJjbNT6N4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/riskassess.png
// module id = qJFv
// module chunks = 1